
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQ from './FAQ';
import GoogleTagManager from '../components/GoogleTagManager';


function Mumbaitovapicab() {



    const cardData =
    {
        keyword: ' Mumbai to Vapi Cab',
        heading: 'Deva Cabs:  Mumbai to Vapi Cab',
        headingDescription: 'Deva Cabs offers reliable, comfortable, and hassle-free cab services from Mumbai to Vapi. Whether you are traveling for business, industrial visits, or a short family trip, our experienced drivers and clean, well-maintained cars ensure a safe and efficient journey. Vapi, known as a key industrial town in Gujarat, lies on the Mumbai–Surat route and is a frequent travel destination for professionals and visitors alike. With flexible booking options, affordable rates, and multiple vehicle choices, Deva Cabs guarantees a smooth and comfortable ride from Mumbai to Vapi every time.',

        top: 'Top Places to Visit in Vapi with Deva Cabs',

"topPlaces": [
  {
    "title": "Nakshatra Garden",
    "location": "Vapi, Gujarat",
    "description": "Located on the scenic Daman Ganga riverbank, Nakshatra Garden is a beautifully landscaped retreat featuring exotic flowers, walking paths, children’s play areas, and calm seating zones. Ideal for family outings, morning jogs, and evening relaxation, the garden lights up beautifully at night, making it a peaceful after-dark destination. :contentReference[oaicite:1]{index=1}"
  },
  {
    "title": "Vanganga Lake & Garden",
    "location": "Silvassa (near Vapi), Dadra & Nagar Haveli and Daman & Diu",
    "description": "A tranquil lakeside garden just a short drive from Vapi, Vanganga features paddle boating, flower beds, jogging paths, and birdwatching opportunities. It’s a great escape for families and nature lovers, blending water-side leisure with lush landscaping. :contentReference[oaicite:2]{index=2}"
  },
  {
    "title": "G.I.D.C. Garden",
    "location": "Vapi, Gujarat",
    "description": "A well-maintained urban park in Vapi’s industrial hub, this GIDC Garden offers open lawns, shaded walking tracks, and picnic spots. A popular pick for evening strolls, relaxing breaks, and community gatherings amidst green surroundings. :contentReference[oaicite:3]{index=3}"
  },
  {
    "title": "Jampore Beach",
    "location": "Daman (12 km from Vapi), Dadra & Nagar Haveli and Daman & Diu",
    "description": "Golden sands, serene waters, and weekend camel- or horse-rides make Jampore Beach a favorite family escape. With eateries lining the shore and gentle waves—perfect for splashing and sightseeing—it’s a peaceful coastal retreat just a short drive away. :contentReference[oaicite:4]{index=4}"
  },
  {
    "title": "Bom Jesus & St. Jerome Churches",
    "location": "Daman (near Vapi)",
    "description": "Explore Portuguese-era Catholic heritage at the ornate Bom Jesus Church and historic St. Jerome Church inside St. Jerome Fort. These architectural gems feature Baroque altarpieces, centuries‑old facades, and a spiritual atmosphere for history buffs and cultural travelers. :contentReference[oaicite:5]{index=5}"
  },
  {
    "title": "Vaibhav Water World & Mirasol Waterpark",
    "location": "Vapi & Daman region",
    "description": "For family fun, these waterparks offer slides, wave pools, kids’ zones, and leisure rides. Vaibhav Water World (in Vapi) and Mirasol Waterpark (near Daman) are top picks for a refreshing outing on warm days. :contentReference[oaicite:6]{index=6}"
  },
  {
    "title": "Daman Ganga Riverfront",
    "location": "Vapi, Gujarat",
    "description": "The scenic banks of the Daman Ganga River are lined with promenades, benches, and greenery. It's a popular spot for evening walks, picnics, and casual meetups, offering a peaceful cityscape of waterways and green belts. :contentReference[oaicite:7]{index=7}"
  },
  {
    "title": "Thrill Zone Adventure Park",
    "location": "Vapi, Gujarat",
    "description": "An adventure facility offering zip‑lining, rock‑climbing, wall rappelling, and other high‑energy activities—making it a go-to spot for young couples and thrill-seekers looking to inject excitement into their Vapi visit. :contentReference[oaicite:8]{index=8}"
  },
  {
    "title": "Silvassa: Tribal Museum & Island Gardens",
    "location": "Silvassa (near Vapi)",
    "description": "Just across the border in Dadra & Nagar Haveli, Silvassa offers cultural experiences at the Tribal Cultural Museum and peaceful outings at Island Garden and Hirwa Van Garden—with paddle boats, shaded walkways, and lush tree cover. :contentReference[oaicite:9]{index=9}"
  },
  {
    "title": "Jubilee & Janseva Parks",
    "location": "Vapi, Gujarat",
    "description": "Two additional tranquil green spaces in Vapi city—Jubilee Garden and Janseva Park—featuring walking trails, manicured lawns, benches, and family-friendly environments, ideal for easy city getaways. :contentReference[oaicite:10]{index=10}"
  }
],



"services": [
    {
        "name": "Mumbai to Vapi Cab",
        "description": "Travel comfortably from Mumbai to Vapi with our reliable cab service. Whether it’s a business trip, family visit, or leisure travel, our Mumbai to Vapi cabs provide a safe and punctual ride. Choose from a variety of vehicles including sedans and SUVs, all maintained to high standards. Our experienced drivers ensure a smooth journey on this popular route, offering door-to-door service with transparent pricing and 24/7 customer support."
    },
    {
        "name": "Outstation Cab Mumbai to Vapi",
        "description": "Planning an outstation trip to Vapi from Mumbai? Our outstation cab service offers flexible travel options perfect for weekend getaways, corporate travel, or family outings. With well-maintained vehicles and professional chauffeurs, you can relax and enjoy your journey. We provide both one-way and round-trip packages tailored to your schedule, ensuring hassle-free travel with competitive fares and no hidden costs."
    },
    {
        "name": "One Way Cab to Vapi from Mumbai",
        "description": "Our one-way cab service from Mumbai to Vapi is ideal for travelers needing a straightforward, cost-effective trip without the obligation of a return journey. Whether you’re visiting friends, attending an event, or traveling for work, our one-way taxis offer convenience and comfort at affordable rates. Choose from AC sedans, SUVs, or luxury cars to suit your travel needs."
    },
    {
        "name": "Round Trip Cab Mumbai to Vapi",
        "description": "Book a round trip cab from Mumbai to Vapi and enjoy the convenience of a dedicated vehicle waiting for your return journey. Our round-trip packages are designed to offer savings and flexibility, allowing you to focus on your plans in Vapi without worrying about transportation. Our drivers are familiar with the routes and ensure timely pickups, clean vehicles, and excellent customer service throughout your trip."
    },
    {
        "name": "Affordable Vapi Cab Mumbai",
        "description": "Looking for affordable yet reliable cab services from Mumbai to Vapi? Our budget-friendly cabs provide great value without compromising comfort or safety. Perfect for families, solo travelers, and groups, our affordable cab options include well-maintained cars driven by professional chauffeurs. We offer transparent pricing and flexible booking to suit your travel plans."
    },
    {
        "name": "Book Cab Online Mumbai to Vapi",
        "description": "Booking a cab from Mumbai to Vapi is now quick and easy with our online platform. Choose your preferred vehicle type, select your travel dates, and confirm your booking in just a few clicks. Our online booking system ensures instant confirmation, transparent fare details, and hassle-free payment options. Experience the convenience of booking your trip anytime, anywhere."
    },
    {
        "name": "Chauffeur Cab to Vapi from Mumbai",
        "description": "Experience premium chauffeur-driven cab services from Mumbai to Vapi, where comfort, safety, and professionalism come first. Our skilled drivers are trained to provide a smooth ride, punctual pickups, and courteous service. Whether it’s a corporate trip or a personal journey, our chauffeur cabs offer privacy, luxury, and a stress-free travel experience."
    },
    {
        "name": "SUV Cab Hire to Vapi",
        "description": "Travel with ample space and comfort in our SUV cabs from Mumbai to Vapi. Ideal for families, groups, or travelers with extra luggage, our SUVs offer roomy interiors, air conditioning, and a smooth ride. Our SUVs are driven by experienced drivers familiar with the highway routes, ensuring a safe and enjoyable journey at competitive rates."
    },
    {
        "name": "Mumbai to Vapi AC Cab",
        "description": "Beat the heat with our air-conditioned cab services from Mumbai to Vapi. Our AC cabs provide a cool and comfortable environment throughout your journey. Whether traveling for business or leisure, our clean and well-maintained AC vehicles ensure you arrive fresh and relaxed. Book our AC cab service for a pleasant ride with excellent customer support."
    },
    {
        "name": "Mumbai to Vapi Luxury Cab",
        "description": "Indulge in luxury travel from Mumbai to Vapi with our premium cab options. Our luxury cars feature plush interiors, advanced amenities, and professional chauffeurs dedicated to providing you with an exclusive travel experience. Perfect for VIP guests, corporate clients, or anyone seeking an elevated journey, our luxury cab service promises style, comfort, and punctuality."
    },
    {
        "name": "Premium Vapi Cab Service Mumbai",
        "description": "Our premium cab service from Mumbai to Vapi is designed for travelers who expect the highest standards in vehicle quality, driver professionalism, and customer care. Enjoy spacious, elegant vehicles equipped with modern features and driven by courteous drivers who prioritize your safety and comfort. This service is perfect for business travelers, families, and special occasions."
    },
    {
        "name": "Corporate Cab to Vapi",
        "description": "Enhance your corporate travel experience with our dedicated Mumbai to Vapi corporate cab service. We offer punctual, reliable, and discreet transportation tailored to meet business schedules. Our professional chauffeurs understand corporate etiquette and provide a comfortable environment suitable for preparing for meetings or unwinding after a long day. Flexible booking and billing options make managing corporate travel seamless."
    },
    {
        "name": "Family Cab to Vapi Mumbai",
        "description": "Planning a family trip from Mumbai to Vapi? Our family cab service offers spacious, safe, and comfortable vehicles perfect for traveling with children and elders. We prioritize your family’s convenience with reliable pick-ups, flexible timing, and courteous drivers experienced in family travel needs. Our cabs ensure a smooth and enjoyable journey to make your family outing memorable."
    }
],

"tableData": [
    ["Mumbai to Vapi Cab", "-Outstation Cab Mumbai to Vapi"],
    ["One Way Cab to Vapi from Mumbai", "-Round Trip Cab Mumbai to Vapi"],
    ["Affordable Vapi Cab Mumbai", "-Book Cab Online Mumbai to Vapi"],
    ["Chauffeur Cab to Vapi from Mumbai", "-SUV Cab Hire to Vapi"],
    ["Mumbai to Vapi AC Cab", "-Mumbai to Vapi Luxury Cab"],
    ["Premium Vapi Cab Service Mumbai", "-Corporate Cab to Vapi"],
    ["Family Cab to Vapi Mumbai"]
],

whychoose: [
  {
    "WhyChooseheading": "Reliable and On-Time Pickup from Mumbai",
    "WhyChoosedescription": "Whether you're heading to Vapi for business, family visits, or a relaxing weekend, Deva Cabs ensures a punctual start to your journey. Our drivers arrive on time, every time—right at your doorstep anywhere in Mumbai. With real-time driver tracking, automated alerts, and a strong commitment to reliability, you never have to worry about delays or missed appointments. Your time matters, and we make sure it's respected."
  },
  {
    "WhyChooseheading": "Clean, Spacious, and Comfortable Vehicles",
    "WhyChoosedescription": "Enjoy a comfortable ride from Mumbai to Vapi in one of our premium cabs, designed for long-distance travel. Whether you choose a sedan or an SUV, every vehicle in our fleet is air-conditioned, sanitized, and equipped with plush seating, ample legroom, and generous luggage space. The journey is made smoother with a quiet cabin, clean interiors, and suspension designed for highway drives—turning a few hours of travel into a relaxing break."
  },
  {
    "WhyChooseheading": "Trained and Courteous Drivers with Route Expertise",
    "WhyChoosedescription": "Our drivers don’t just drive—they ensure your ride is safe, smooth, and pleasant. Well-versed in the Mumbai to Vapi route via NH48, they avoid traffic-prone zones, know ideal stopovers, and maintain professional conduct throughout. Polite, punctual, and verified, Deva Cabs drivers go the extra mile to make your intercity travel experience stress-free and enjoyable."
  },
  {
    "WhyChooseheading": "Transparent and Affordable Fare Structure",
    "WhyChoosedescription": "No more guessing games or surprise charges. Deva Cabs offers fully transparent pricing for your Mumbai to Vapi cab ride. You’ll receive a detailed fare estimate upfront, with no hidden fees for tolls, luggage, or night-time pickups. Our rates are competitive, honest, and built for peace of mind—so you know exactly what you’re paying before your journey begins."
  },
  {
    "WhyChooseheading": "24/7 Availability for Flexible Travel Plans",
    "WhyChoosedescription": "Whether it’s an early morning business trip, a late-night return, or a same-day round trip, our Mumbai to Vapi cab service runs 24x7 to match your schedule. No matter the time or day, simply book through our app, website, or helpline—and we’ll be there when you need us. Our always-on availability means you can plan your travel with complete freedom."
  },
  {
    "WhyChooseheading": "Safety-First Approach for Every Journey",
    "WhyChoosedescription": "Your safety is non-negotiable. That’s why all Deva Cabs are GPS-enabled, thoroughly sanitized, and driven by background-verified professionals. We follow strict vehicle inspection protocols and road safety regulations. Whether you're traveling solo or with family, you can count on us for a secure and comfortable experience on the Mumbai–Vapi highway."
  },
  {
    "WhyChooseheading": "Quick Booking with Real-Time Driver Tracking",
    "WhyChoosedescription": "Booking a Mumbai to Vapi cab is effortless with Deva Cabs. Use our intuitive app or website to book in under a minute. Receive instant confirmation, driver details, and live tracking so you’re always in control. For those who prefer voice support, our 24/7 customer care team is ready to help with bookings, rescheduling, or special requests."
  },
  {
    "WhyChooseheading": "Customizable Travel Options for All Needs",
    "WhyChoosedescription": "From one-way drops to round trips and even hourly rentals, Deva Cabs offers customizable packages for your Mumbai to Vapi trip. Whether you're heading to an industrial site, a family function, or a quick getaway, we tailor our service to your purpose. Choose your pickup time, cab type, and route preferences—we’ll handle the rest."
  }
]










    }




const faqData = [
  {
    question: "Can I book a cab from Mumbai to Vapi with Deva Cabs?",
    answer: "Yes, Deva Cabs offers reliable and convenient cab services from Mumbai to Vapi. You can easily book your ride via our website, mobile app, or by contacting our customer support."
  },
  {
    question: "What vehicle options are available for the Mumbai to Vapi trip?",
    answer: "We offer a variety of vehicles including hatchbacks, sedans, SUVs, and premium cars, so you can choose the one that best suits your needs for the Mumbai to Vapi journey."
  },
  {
    question: "How long does the journey from Mumbai to Vapi take?",
    answer: "The journey from Mumbai to Vapi typically takes around 3 to 4 hours depending on the traffic and road conditions."
  },
  {
    question: "Can I book a one-way cab from Mumbai to Vapi?",
    answer: "Yes, you can easily book a one-way cab from Mumbai to Vapi without any additional charges for the one-way journey."
  },
  {
    question: "What are the payment options for the Mumbai to Vapi cab ride?",
    answer: "We accept cash, credit/debit cards, UPI, and online payments via our mobile app or website for your Mumbai to Vapi cab ride."
  },
  {
    question: "Can I pre-schedule my ride from Mumbai to Vapi?",
    answer: "Yes, you can pre-schedule your ride from Mumbai to Vapi through our booking portal or mobile app. Choose your preferred date and time for guaranteed pick-up."
  },
  {
    question: "Are the drivers experienced for the Mumbai to Vapi cab ride?",
    answer: "Yes, all our drivers are experienced, verified, and familiar with the Mumbai to Vapi route, ensuring a safe and smooth journey."
  },
  {
    question: "Is it safe to travel from Mumbai to Vapi with Deva Cabs?",
    answer: "Absolutely! All our cabs are GPS-enabled, and we ensure the highest safety standards with professional drivers dedicated to your comfort."
  }
];

const testimonialData = [
  {
    id: 1,
    name: 'Mr. Rajesh Patil',
    role: 'Frequent Traveler',
    review: 'I travel from Mumbai to Vapi regularly for work, and Deva Cabs always provides a reliable, comfortable, and safe service. The drivers are punctual, and the cars are well-maintained.',
    rating: 5,
    quoteIcon: '/img/icon/testi-quote.svg',
  },
  {
    id: 2,
    name: 'Ms. Simran Desai',
    role: 'Tourist',
    review: 'I took a cab from Mumbai to Vapi for a trip with friends. The experience was amazing! The ride was smooth, and the driver was very friendly. I’ll definitely choose Deva Cabs again for my next trip.',
    rating: 5,
    quoteIcon: '/img/icon/testi-quote.svg',
  }
];































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8108807171",
            "+91 9764227171",



        ],
        email: "booking@devacab.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Cab Service in Mumbai",
            link: "/Cab-Service-in-Mumbai"
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Cab Service in Navi Mumbai",
            link: "/Cab-Service-in-Navi-Mumbai"
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Cab Service in Thane",
            link: "/Cab-Service-in-Thane"
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Cab Service Near Me Mumbai",
            link: "/Cab-Service-Near-Me-Mumbai"
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Car Rental in Mumbai",
            link: "/Car-Rental-in-Mumbai"
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Corporate Cab Services in Mumbai",
            link: "/Corporate-Cab-Services-in-Mumbai"
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Online Taxi Booking Mumbai",
            link: "/Online-Taxi-Booking-Mumbai"
        },
        {
            place: "/images/keyword/8.jpg",
            text: "Wedding Car Rental Mumbai",
            link: "/Wedding-Car-Rental-Mumbai"
        },
        {
            place: "/images/keyword/9.jpg",
            text: "Tempo Traveller on Rent in Mumbai",
            link: "/Tempo-Traveller-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Innova Crysta on Rent in Mumbai",
            link: "/Innova-Crysta-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/11.jpg",
            text: "Ertiga on Rent in Mumbai",
            link: "/Ertiga-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Mini Bus on Rent in Mumbai",
            link: "/Mini-Bus-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/13.jpg",
            text: "Mumbai Airport Cab Booking",
            link: "/Mumbai-Airport-Cab-Booking"
        },
        {
            place: "/images/keyword/14.jpg",
            text: "Navi Mumbai Car Rental Service",
            link: "/Navi-Mumbai-Car-Rental-Service"
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Mumbai Airport to Pune Cab",
            link: "/Mumbai-Airport-to-Pune-Cab"
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Mumbai Airport to Shirdi Taxi",
            link: "/Mumbai-Airport-to-Shirdi-Taxi"
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Mumbai Airport Cab",
            link: "/Pune-to-Mumbai-Airport-Cab"
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Airport to Mumbai Cab",
            link: "/Pune-Airport-to-Mumbai-Cab"
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Surat to Mumbai Airport Taxi",
            link: "/Surat-to-Mumbai-Airport-Taxi"
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Nashik to Mumbai Airport Cab",
            link: "/Nashik-to-Mumbai-Airport-Cab"
        },
        {
            place: "/images/keyword/21.jpg",
            text: "Mumbai to Nashik Cab",
            link: "/Mumbai-to-Nashik-Cab"
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Mumbai to Shirdi Cab",
            link: "/Mumbai-to-Shirdi-Cab"
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Mumbai to Lonavala Cab",
            link: "/Mumbai-to-Lonavala-Cab"
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Mumbai to Khandala Cab",
            link: "/Mumbai-to-Khandala-Cab"
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Mumbai to Lavasa Cab",
            link: "/Mumbai-to-Lavasa-Cab"
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Mumbai to Matheran Cab",
            link: "/Mumbai-to-Matheran-Cab"
        }
    ];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },

    ];


const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Vapi Cab",
  "image": "https://devacab.com/assets/images/mumbai-to-vapi-cab.jpg", // Replace with actual image URL
  "description": "Book reliable and affordable Mumbai to Vapi cab service with Deva Cabs. Outstation one-way and round trip cabs with AC, SUV, luxury, and chauffeur-driven options. Ideal for family, business, and corporate travel.",
  "brand": {
    "@type": "Brand",
    "name": "Deva Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "4200"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3000", // Example price, adjust as needed
    "availability": "https://schema.org/InStock",
    "url": "https://devacab.com/mumbai-to-vapi-cab" // Replace with actual page URL
  }
};






    return (
        <div>
<GoogleTagManager/>
<Helmet>
  <title>Mumbai to Vapi Cab | Book One-Way & Round Trip Taxi | Deva Cabs</title>
  <meta
    name="description"
    content="Book Mumbai to Vapi cab with Deva Cabs. Affordable outstation taxi for one-way and round trips. AC, SUV, luxury, and chauffeur-driven cab options for family, corporate, and business travel."
  />
  <meta
    name="keywords"
    content="Mumbai to Vapi Cab, Outstation cab Mumbai to Vapi, One way cab to Vapi from Mumbai, Round trip cab Mumbai to Vapi, Affordable Vapi cab Mumbai, Book cab online Mumbai to Vapi, Chauffeur cab to Vapi from Mumbai, SUV cab hire to Vapi, Mumbai to Vapi AC cab, Mumbai to Vapi luxury cab, Premium Vapi cab service Mumbai, Corporate cab to Vapi, Family cab to Vapi Mumbai"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>




            <div className="breadcumb-wrapper" >
                <div className="container">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>



            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/75.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F8911B', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                // padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    // padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className=''>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Deva Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQ faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword testimonialData={testimonialData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1" key={e.text}>
                                        <a
                                            href={e.link} // Use the separate link for each item
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt={e.text} />
                                            </div>
                                            <div className="b2">
                                                <a href={e.link} className="px-3 colorr">{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #562018',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#562018' }}>
                                            <h4 className=" lead fw-semibold whitt text-white bg-ora">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+91 8108807171" className="d-block  text-white">+91 8108807171</a>
                                                <a href="tel:+91 9764227171" className="d-block  text-white">+91 9764227171</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#562018' }}>
                                                <h4 className=" fw-semibold lead whitt text-white bg-ora">Email</h4>
                                                <a href="mailto:booking@devacab.com" className=" text-white d-block">
                                                    booking@devacab.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#562018' }}>
                                                <h4 className=" fw-semibold lead whitt text-white bg-ora">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Deva Cabs<br />
                                                        SS-2 404 Sector -17 Behind Mother India School Koparkhairne Navi Mumbai 400709
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>

        </div>
    );
}

export default Mumbaitovapicab;